<div class="error-tag" [ngClass]="{ error: showError }">
  <div [ngClass]="{ 'error-message-active': errorMessage }" class="error-message">{{ errorMessage }}</div>
</div>
